import { SortOrder } from "../../constants/sort-order";
import { SortTypes } from "../../constants/sort-types";
import { SortModel } from "./sort-model";
import { SortOptionMap } from "./sort-option-map";

export const SortOptions = {
	"price-htl": {
		Id: SortTypes.PriceHtL,
		Label: "Price",
		Type: "High - low",
		SortOrder: SortOrder.Descending,
	} as SortModel,
	"price-lth": {
		Id: SortTypes.PriceLtH,
		Label: "Price",
		Type: "Low - high",
		SortOrder: SortOrder.Ascending,
	} as SortModel,
	"sqf-htl": {
		Id: SortTypes.SqFtHtL,
		Label: "Sq. ft.",
		Type: "High - low",
		SortOrder: SortOrder.Descending,
	} as SortModel,
	"sqf-lth": {
		Id: SortTypes.SqFtLtH,
		Label: "Sq. ft.",
		Type: "Low - high",
		SortOrder: SortOrder.Ascending,
	} as SortModel,
	"city-az": {
		Id: SortTypes.CityAZ,
		Label: "City",
		Type: "A - Z",
		SortOrder: SortOrder.Ascending,
	} as SortModel,
	"name-az": {
		Id: SortTypes.NameAZ,
		Label: "Name",
		Type: "A - Z",
		SortOrder: SortOrder.Ascending,
	} as SortModel,
} as SortOptionMap;
